import { IMG_BASE_URL } from './misc.js';

const STATE_LIST = [
    {
        id: 1,
        name: "Maharashtra",
        code: "MH",
        zone_id: 3,
        state_cover_image: `${IMG_BASE_URL}/gateway_of_india_maharashtra_uggur8.png`,
        state_icon: `${IMG_BASE_URL}/Maharashtra_ljdbv8.png`
    },
    {
        id: 2,
        name: "Delhi",
        code: "DL",
        zone_id: 1,
        state_cover_image: `${IMG_BASE_URL}/lotus_temple_delhi_x7ahtk.png`,
        state_icon: `${IMG_BASE_URL}/Delhi_fi1lnq.png`
    },
    {
        id: 3,
        name: "Karnataka",
        code: "KA",
        zone_id: 2,
        state_cover_image: `${IMG_BASE_URL}/hampi_karnataka_j5avow.png`,
        state_icon: `${IMG_BASE_URL}/Karnataka_ugrakh.png`
    },
    {
        id: 4,
        name: "Gujarat",
        code: "GJ",
        zone_id: 3,
        state_cover_image: `${IMG_BASE_URL}/somanath_mandir_gujarat_m25axk.png`,
        state_icon: `${IMG_BASE_URL}/Gujarat_ndcfp6.png`
    },
    {
        id: 5,
        name: "Telangana",
        code: "TG",
        zone_id: 2,
        state_cover_image: `${IMG_BASE_URL}/charminar_telangana_trcbch.png`,
        state_icon: `${IMG_BASE_URL}/Telangana_cl2zms.png`
    },
    {
        id: 6,
        name: "Tamil Nadu",
        code: "TN",
        zone_id: 2,
        state_cover_image: `${IMG_BASE_URL}/mahabalipuram_temple_tamil_nadu_edplkn.png`,
        state_icon: `${IMG_BASE_URL}/Tamil_Nadu_tu0b8o.png`
    },
    {
        id: 7,
        name: "West Bengal",
        code: "WB",
        zone_id: 4,
        state_cover_image: `${IMG_BASE_URL}/victoria_palace_west_bengal_lragc4.png`,
        state_icon: `${IMG_BASE_URL}/West_Bengal_ilwmiz.png`
    },
    {
        id: 8,
        name: "Rajasthan",
        code: "RJ",
        zone_id: 3,
        state_cover_image: `${IMG_BASE_URL}/hawa_mahal_rajasthan_nlqzlw.png`,
        state_icon: `${IMG_BASE_URL}/Rajasthan_r2o6wp.png`
    },
    {
        id: 9,
        name: "Uttar Pradesh",
        code: "UP",
        zone_id: 3,
        state_cover_image: `${IMG_BASE_URL}/taj_mahal_up_gckaue.png`,
        state_icon: `${IMG_BASE_URL}/Uttar_Pradesh_jcmp3s.png`
    },
    {
        id: 10,
        name: "Bihar",
        code: "BR",
        zone_id: 5,
        state_cover_image: `${IMG_BASE_URL}/bodh_gaya_bihar_wrpijx.png`,
        state_icon: `${IMG_BASE_URL}/Bihar_hq1tz7.png`
    },
    {
        id: 11,
        name: "Madhya Pradesh",
        code: "MP",
        zone_id: 3,
        state_cover_image: `${IMG_BASE_URL}/khajurao_mp_nigqvq.png`,
        state_icon: `${IMG_BASE_URL}/Madhya_Pradesh_qbxzbx.png`
    },
    {
        id: 12,
        name: "Andhra Pradesh",
        code: "AP",
        zone_id: 2,
        state_cover_image: `${IMG_BASE_URL}/srikodandaramaswamy_temple_vontimitta_andhra_pradesh_wezot0.png`,
        state_icon: `${IMG_BASE_URL}/Andhra_Pradesh_fixb1v.png`
    },
    {
        id: 13,
        name: "Punjab",
        code: "PB",
        zone_id: 1,
        state_cover_image: `${IMG_BASE_URL}/golden_temple_punjab_c9xnol.png`,
        state_icon: `${IMG_BASE_URL}/Punjab_rufdm3.png`
    },
    {
        id: 14,
        name: "Haryana",
        code: "HR",
        zone_id: 1,
        state_cover_image: `${IMG_BASE_URL}/sheikh_chilli_tomb_haryana_yztrpx.png`,
        state_icon: `${IMG_BASE_URL}/Haryana_q4x7jr.png`
    },
    {
        id: 15,
        name: "Jammu And Kashmir",
        code: "JK",
        zone_id: 1,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Jammu_and_Kashmir_fptocu.png`
    },
    {
        id: 16,
        name: "Jharkhand",
        code: "JH",
        zone_id: 5,
        state_cover_image: `${IMG_BASE_URL}/maluti_temples_jharkhand_rp5xya.png`,
        state_icon: `${IMG_BASE_URL}/Jharkhand_tdz22q.png`
    },
    {
        id: 17,
        name: "Chhattisgarh",
        code: "CG",
        zone_id: 5,
        state_cover_image: `${IMG_BASE_URL}/laxmantemple_sirpur_chhattisgarh_hzdam6.png`,
        state_icon: `${IMG_BASE_URL}/Chhattisgarh_xou0vi.png`
    },
    {
        id: 18,
        name: "Assam",
        code: "AS",
        zone_id: 4,
        state_cover_image: `${IMG_BASE_URL}/rangghar_assam_aexuir.png`,
        state_icon: `${IMG_BASE_URL}/Assam_dgwsoi.png`
    },
    {
        id: 19,
        name: "Chandigarh",
        code: "Chandigarh",
        zone_id: 1,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Chandigarh_xpar8t.png`
    },
    {
        id: 20,
        name: "Odisha",
        code: "OD",
        zone_id: 5,
        state_cover_image: `${IMG_BASE_URL}/konark_odisha_y68uv5.png`,
        state_icon: `${IMG_BASE_URL}/Odisha_vlowwp.png`
    },
    {
        id: 21,
        name: "Kerala",
        code: "KL",
        zone_id: 2,
        state_cover_image: `${IMG_BASE_URL}/kerala_ylkqkv.png`,
        state_icon: `${IMG_BASE_URL}/Kerala_jlzpix.png`
    },
    {
        id: 22,
        name: "Uttarakhand",
        code: "UK",
        zone_id: 1,
        state_cover_image: `${IMG_BASE_URL}/kedarnath_uttarakhand_yslyna.png`,
        state_icon: `${IMG_BASE_URL}/Uttarakhand_kwgsxe.png`
    },
    {
        id: 23,
        name: "Puducherry",
        code: "PY",
        zone_id: 2,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Puducherry_warals.png`
    },
    {
        id: 24,
        name: "Tripura",
        code: "TR",
        zone_id: 4,
        state_cover_image: `${IMG_BASE_URL}/rabdentse_palace_sikkim_lfxcam.png`,
        state_icon: `${IMG_BASE_URL}/Tripura_mcjota.png`
    },
    {
        id: 25,
        name: "Mizoram",
        code: "MZ",
        zone_id: 4,
        state_cover_image: `${IMG_BASE_URL}/aizawl_mizoram_xexevq.png`,
        state_icon: `${IMG_BASE_URL}/Mizoram_tnzij9.png`
    },
    {
        id: 26,
        name: "Meghalaya",
        code: "ML",
        zone_id: 4,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Meghalaya_ccenvn.png`
    },
    {
        id: 27,
        name: "Manipur",
        code: "MN",
        zone_id: 4,
        state_cover_image: `${IMG_BASE_URL}/kangla_fort_manipur_n047zh.png`,
        state_icon: `${IMG_BASE_URL}/Manipur_wpj3sb.png`
    },
    {
        id: 28,
        name: "Himachal Pradesh",
        code: "HP",
        zone_id: 1,
        state_cover_image: `${IMG_BASE_URL}/rashtrapati_niwas_shimla_himachal_pradesh_hxoiur.png`,
        state_icon: `${IMG_BASE_URL}/Himachal_Pradesh_ylfxgz.png`
    },
    {
        id: 29,
        name: "Nagaland",
        code: "NL",
        zone_id: 4,
        state_cover_image: `${IMG_BASE_URL}/kohima_cemetery_nagaland_awuzdd.png`,
        state_icon: `${IMG_BASE_URL}/Nagaland_cdvqsn.png`
    },
    {
        id: 30,
        name: "Goa",
        code: "GA",
        zone_id: 2,
        state_cover_image: `${IMG_BASE_URL}/bom_jesus_basilica_goa_blczvz.png`,
        state_icon: `${IMG_BASE_URL}/Goa_hu1cwh.png`
    },
    {
        id: 31,
        name: "Andaman And Nicobar Islands",
        code: "AN",
        zone_id: 4,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Andaman_Nicobar_Islands_glqjjl.png`
    },
    {
        id: 32,
        name: "Arunachal Pradesh",
        code: "AR",
        zone_id: 4,
        state_cover_image: `${IMG_BASE_URL}/tawang_monastery_arunachal_pradesh_wj8aes.png`,
        state_icon: `${IMG_BASE_URL}/Arunachal_Pradesh_e8zcuo.png`
    },
    {
        id: 33,
        name: "Dadra and Nagar Haveli and Daman and Diu",
        code: "DN",
        zone_id: 3,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Daman_Diu_pashu2.png`
    },
    {
        id: 34,
        name: "North Eastern",
        code: "NE",
        zone_id: 4,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Ladakh_hywqz4.png`
    },
    {
        id: 35,
        name: "Sikkim",
        code: "SK",
        zone_id: 4,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Sikkim.png`
    },
    {
        id: 36,
        name: "Ladakh",
        code: "LA",
        zone_id: 1,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Himachal_Pradesh_ylfxgz.png`
    },
    {
        id: 37,
        name: "Lakshadweep",
        code: "LD",
        zone_id: 2,
        state_cover_image: "",
        state_icon: `${IMG_BASE_URL}/Andaman_Nicobar_Islands_glqjjl.png`
    }
];
const STATE_ID_LIST = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
    32, 33, 34, 35, 36, 37
];
const TEST_LOAD_STATE_ID = 31;
const STATE_ID_LIST_NOT_FOR_TESTING = STATE_ID_LIST.filter((st) => ![31].includes(st));

export { STATE_ID_LIST, STATE_ID_LIST_NOT_FOR_TESTING, STATE_LIST, TEST_LOAD_STATE_ID };
//# sourceMappingURL=StateList.js.map
